import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class DeductionSkipComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/deduction';
  }

  public static regex(): RegExp {
    return /(\/statement\/)\d+\/deduction((\/?#?)|(\/?#.*?))$/;
  }
}
